import { render } from "./loading-overlay.vue?vue&type=template&id=91047e5a"
import script from "./loading-overlay.vue?vue&type=script&lang=js"
export * from "./loading-overlay.vue?vue&type=script&lang=js"
script.render = render

export default script